import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import shortid from "shortid";

import useHttp from "../../../../hooks/useHttp";
import { LOAD_POST_OFFERS_GET_URL } from "../../../../utils/api-ends";
import Rating from "../../../../components/Rating";
import LoaderImg from "../../../../assets/media/loader.gif";
import {
  REJECT_COUNTER_OFFER_URL,
  STOP_COUNTER_OFFER_URL,
} from "../../../../utils/api-ends";
import { ManageLoadPostDetailPageContext } from "../";
import { PAYMENT_REQUEST_POST_URL } from "../../../../utils/api-ends";

const CarrierOffers = () => {
  const [totalOffers, setTotalOffers] = useState(0);
  const [loadPostDetailState, loadPostDetailContextDispatch] = useContext(
    ManageLoadPostDetailPageContext
  );
  const [selectedOfferToAccept, setSelectedOfferToAccept] = useState("");
  const [selectedOfferToReject, setSelectedOfferToReject] = useState("");
  const [selectedOfferToStop, setSelectedOfferToStop] = useState("");

  const { loadPostId } = useParams();
  const navigate = useNavigate();
  const { isLoading: isLoadingFetchCarrierOffers, sendRequests: fetchOffers } =
    useHttp();
  const { isLoading: loadingAcceptOffer, sendRequests: acceptOfferRequest } =
    useHttp();
  const { isLoading: loadingRejectOffer, sendRequests: rejectOfferRequest } =
    useHttp();
  const { isLoading: loadingStopOffer, sendRequests: stopOfferRequest } =
    useHttp();

  const fetchOfferList = (loadPostId, pageNumber) => {
    const response = (data) => {
      setTotalOffers(data.total_offers);
      loadPostDetailContextDispatch({
        type: "LOAD_MORE_OFFERS",
        payload: data.data,
      });
    };
    fetchOffers(
      {
        url: LOAD_POST_OFFERS_GET_URL(loadPostId),
        params: {
          page: pageNumber,
        },
      },
      response
    );
  };

  // Fetch offers
  useEffect(() => {
    const response = (data) => {
      setTotalOffers(data.total_offers);
      loadPostDetailContextDispatch({
        type: "FETCH_OFFER_LIST",
        payload: data.data,
      });
    };
    fetchOffers(
      {
        url: LOAD_POST_OFFERS_GET_URL(loadPostId),
      },
      response
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPostId]);

  const handleAcceptCounterOffer = (offerId) => {
    const response = (data) => {
      navigate(`/payment/${data?.data}/card-payment`);
    };
    acceptOfferRequest(
      {
        url: PAYMENT_REQUEST_POST_URL,
        method: "post",
        data: {
          payment_for: "create_order",
          payment_notes: {
            offer_id: offerId,
          },
        },
      },
      response
    );
    setSelectedOfferToAccept(offerId); // For show loading to specific button
  };

  const handleRejectCounterOffer = (offerId) => {
    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "SHIPPER_REJECT_COUNTER_OFFER",
        payload: offerId,
      });
    };
    rejectOfferRequest(
      {
        url: REJECT_COUNTER_OFFER_URL(offerId),
        method: "patch",
      },
      response
    );
    setSelectedOfferToReject(offerId); // For show loading to specific button
  };

  const handleStopCounterOffer = (offerId) => {
    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "SHIPPER_STOP_COUNTER_OFFER",
        payload: offerId,
      });
    };
    stopOfferRequest(
      {
        url: STOP_COUNTER_OFFER_URL(offerId),
        method: "patch",
      },
      response
    );
    setSelectedOfferToStop(offerId); // For show loading to specific button
  };

  const handleOpenCounterModal = (offerId, offerAmount) => {
    loadPostDetailContextDispatch({
      type: "OPEN_COUNTER_MODAL",
      payload: {
        data: {
          id: offerId,
          amount: offerAmount,
        },
        openFrom: "shipper_page",
      },
    });
  };

  const handleOpenOfferDetailsModal = (offer) =>
    loadPostDetailContextDispatch({
      type: "OPEN_OFFER_DETAILS_MODAL",
      payload: {
        data: offer,
      },
    });

  return (
    <section>
      <div className="container theme-section">
        <h1 className="large-text text-center mb-4">
          Carrier Offers ({totalOffers})
        </h1>

        {isLoadingFetchCarrierOffers ? (
          <div className="loader d-flex justify-content-center mb-5 mt-5">
            <img style={{ width: "35px" }} src={LoaderImg} alt="" />
          </div>
        ) : loadPostDetailState?.offerList?.results?.length > 0 ? (
          <div className="carrier-offer-table-wrapper">
            <div className="carrier-offer-table">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Carriers</th>
                    <th scope="col">Description</th>
                    <th scope="col">Offer Amount </th>
                    <th scope="col">Counter Offer</th>
                    <th scope="col">Counter Offer Status</th>
                    <th scope="col">Fixed Offer</th>
                    <th scope="col">Pickup Datetime</th>
                    <th scope="col">
                      Estimated Duration <br /> Of Delivery (hours)
                    </th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loadPostDetailState?.offerList?.results?.map((offer) => (
                    <tr key={shortid.generate()}>
                      <td>
                        <div className="loader-user-info">
                          <div className="loader-user-img">
                            <img src={offer?.carrier?.profile_picture} alt="" />
                          </div>

                          <div>
                            <h1 className="large-text">
                              {offer?.carrier?.username}
                            </h1>
                            <div className="user-rating">
                              {!["", null, undefined].includes(
                                offer?.carrier?.avg_rating
                              ) && (
                                <Rating rating={offer?.carrier?.avg_rating} />
                              )}
                              <span>({offer?.carrier?.avg_rating})</span>
                            </div>
                            <span className="post-date">
                              {offer?.created_date}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="multiple-btn description-expand">
                          <button
                            onClick={() => handleOpenOfferDetailsModal(offer)}
                          >
                            Expand
                          </button>
                        </div>
                      </td>
                      <td>$ {offer?.amount}</td>
                      <td>
                        ${" "}
                        {!["", null, undefined].includes(offer?.counter_amount)
                          ? offer?.counter_amount
                          : "- - -"}
                      </td>
                      <td>{offer?.counter_status_display}</td>
                      <td>
                        {offer?.is_counter_amount_fixed === true ? (
                          <i className="fa-solid fa-check"></i>
                        ) : (
                          <i className="fa-solid fa-xmark"></i>
                        )}
                      </td>
                      <td>{offer?.pickup_time_formate}</td>
                      <td>{offer?.estimated_delivery_time}</td>
                      <td>
                        <div className="multiple-btn offer-table-action-btn">
                          {offer?.status === "pending" &&
                            loadPostDetailState?.loadPostDetail?.status ===
                              "running" && (
                              <button
                                onClick={() =>
                                  handleAcceptCounterOffer(offer?.id)
                                }
                              >
                                Accept Offer
                                {loadingAcceptOffer &&
                                  selectedOfferToAccept === offer?.id && (
                                    <img
                                      style={{ width: "22px" }}
                                      src={LoaderImg}
                                      alt="loader"
                                    />
                                  )}
                              </button>
                            )}

                          {offer?.can_counter === true &&
                            loadPostDetailState?.loadPostDetail?.status ===
                              "running" && (
                              <button
                                onClick={() =>
                                  handleOpenCounterModal(
                                    offer?.id,
                                    offer?.amount
                                  )
                                }
                              >
                                Send Counter Offer
                              </button>
                            )}

                          {offer?.status === "pending" &&
                            offer?.counter_offer_by === "other" &&
                            offer?.counter_status === "in_progress" &&
                            loadPostDetailState?.loadPostDetail?.status ===
                              "running" && (
                              <>
                                <button
                                  onClick={() =>
                                    handleRejectCounterOffer(offer?.id)
                                  }
                                >
                                  Reject Offer
                                  {loadingRejectOffer &&
                                    selectedOfferToReject === offer?.id && (
                                      <img
                                        style={{ width: "22px" }}
                                        src={LoaderImg}
                                        alt="loader"
                                      />
                                    )}
                                </button>
                                <button
                                  onClick={() =>
                                    handleStopCounterOffer(offer?.id)
                                  }
                                >
                                  Stopped Offer
                                  {loadingStopOffer &&
                                    selectedOfferToStop === offer?.id && (
                                      <img
                                        style={{ width: "22px" }}
                                        src={LoaderImg}
                                        alt="loader"
                                      />
                                    )}
                                </button>
                              </>
                            )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* View more data */}

              {loadPostDetailState?.offerList?.pagination?.next_page && (
                <div className="multiple-btn offer-table-action-btn mb-2">
                  <button
                    onClick={() =>
                      fetchOfferList(
                        loadPostId,
                        loadPostDetailState?.offerList?.pagination
                          ?.next_page_number
                      )
                    }
                  >
                    See more
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <p className="text-center">No Offers Found</p>
        )}
      </div>
    </section>
  );
};

export default React.memo(CarrierOffers);
